<template>
    <div class="route-steps" :class="{'route-steps--print' : printStyle}">
        <div v-if="formattedSteps">
            <div v-if="!printStyle" class="sidebar__section route-steps__title bold-small-label">Streckendetails</div>
            <div class="route-steps__main">
                <div class="route-steps__item sidebar__section print-break-avoid" :class="{ 'route-steps__item--clickable' : !printStyle }" v-for="(step, index) in formattedSteps" :key="`route-step-${index}`" @click="showStepOnMapHandler(index)">
                    <div class="route-steps__item__icon" :class="{'route-steps__item__icon--target': step.text === 'Ziel'}">
                        <img v-if="step.icon" :src="step.icon" /> 
                    </div>
                    <div class="route-steps__item__content">
                        <div class="route-steps__item__distances ui-spread-center-vertically">
                                <div class="h3" v-if="printStyle && step.text === 'Ziel'">
                                    Ziel
                                </div>
                                <div class="h3" v-else>
                                    {{ step.relativeDistance }} 
                                </div>
                                <div :class="[{ 'copy-light' : printStyle }, { 'caption' : !printStyle }]">
                                    {{ step.distance }} 
                                </div>
                        </div>
                        <div class="route-steps__item__description" :class="[{ 'copy' : printStyle }, { 'copy-light' : !printStyle }]" v-if="step.text !== 'Ziel' && !printStyle">
                            {{ step.text }}
                        </div>
                        <div class="route-steps__item__description" :class="[{ 'copy' : printStyle }, { 'copy-light' : !printStyle }]" v-if="printStyle">
                            {{ step.text === 'Ziel' ? 'Ziel erreicht' : step.text }}
                        </div>
                        <template v-if="route.mode === 'BIKE' && step.notes">
                            <div class="route-steps__info">
                                <div class="route-steps__info__icons">                                    
                                    <Icon :height="16" :width="16" view-box="0 0 16 16" v-if="step.notes.type === 'BIKE_PUSH_TRACK'">
                                        <IconWarning />
                                    </Icon>
                                    <Icon :height="16" :width="16" v-else>
                                        <IconInfo/>
                                    </Icon>
                                </div>
                           
                                <div class="copy-light-small route-steps__info__text">{{ step.notes.text }}</div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <NoResultsMessage type="STEPS" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatRouteSteps } from '@/utils/route-utils'
import Icon from '@/components/Icon.vue'
import IconInfo from '@/components/icons/IconInfo.vue'
import IconWarning from '@/components/icons/IconWarning.vue'
import eventBus from '@/utils/event-bus';

export default {
    components: {
        NoResultsMessage: () => import(/* webpackChunkName: "NoResultsMessage" */ '@/components/NoResultsMessage.vue'),
        Icon,
        IconInfo,
        IconWarning
    },
    props: {
        steps: {
            type: Array,
            default: () => []
        },
        route: {
            type: Object,
            default: () => {}
        },
        printStyle: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters(['mobile', 'mobileSidebarHeightMode']),
        formattedSteps() {
            return formatRouteSteps(this.steps)
        }
    },
    methods: {
        showStepOnMapHandler(index) {
            if(this.printStyle) return
            const step = this.steps[index]
            const coordinates = step.coordinates
            eventBus.$emit('zoomToCoordinates', [coordinates.longitude, coordinates.latitude])
            if(this.mobile && this.mobileSidebarHeightMode === 'full') this.$store.commit('setMobileSidebarHeightMode', 'middle')
        }
    },
}
</script>

<style lang="scss">
.route-steps {
    $block: &;

    &--print {
        padding: 0;

        #{$block} {
            &__item {
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid $color-black-005;

                &__icon {
                    padding: 0;
                    line-height: 0;
                }

                &__distances {
                    @include mq(mobile-landscape) {
                        flex-direction: column;
                        align-items: flex-start;
                        width: 80px;
                        margin-right: 16px;
                    }
                }

                &__content {
                    padding: 0;
                    border: none;

                    @include mq(mobile-landscape) {
                        display: flex;
                        align-items: center;
                    }
                }
            }
            &__info {
                margin-top: 0;
                margin-left: 10px;
                align-items: center;
            }
        }
    }

    &__title {
        margin-bottom: 10px;
    }

    &__item {
        display: flex;
        padding-top: 10px;

        &--clickable {
            cursor: pointer;
            .no-touch &:hover {
                background-color: $color-grey-lightest;
                border-bottom-color: transparent;
            }
        }

        &__icon {
            width: 24px;
            flex-shrink: 0;
            margin-right: 16px;
            padding: 8px 0 0;

            &--target {
                padding: 0;
            }

            &--small-margin {
                margin-right: 8px;
            }
        }

        &__content {
            padding: 0 0 12px;
            border-bottom: 1px solid $color-black-005;
            flex: 1;

            &--simple {
                border: none;
                padding-bottom: 6px;
            }
        }
    }

    &__info {
        display: flex;
        flex-direction: row;
        margin-top: 11px;

        &__icons {
            margin-right: 7px;
            display: flex;
            color: $color-grey-dark;
            @include flex-center;
            width: 18px;
            height: 18px;
            border-radius: 4px;
            background: $color-black-005;
        }

        &__text {
            line-height: 1.83;
        }
    }
}
</style>
